import { ConsultaPermissao, PermissaoUsuario } from "./acesso.tipos"

const ehTexto = (v: unknown): v is string =>
  typeof v === "string" && v.length > 0

export const normalizarPermissoes = (roles: unknown): PermissaoUsuario[] => {
  if (!roles) return []
  let lista: unknown[] = []

  if (typeof roles === "string") {
    try {
      const parsed = JSON.parse(roles)
      lista = Array.isArray(parsed) ? parsed : [roles]
    } catch {
      lista = [roles]
    }
  } else if (Array.isArray(roles)) {
    lista = roles
  }

  const resultado: PermissaoUsuario[] = []

  for (const item of lista) {
    const str = Array.isArray(item) ? item[0] : item
    if (!ehTexto(str)) continue
    const partes = str.split("_")
    if (partes.length >= 2) {
      const modulo = partes[0]
      const acao = partes[1]
      const filtro = partes.slice(2).join("_") || undefined
      resultado.push({ nome: str, modulo, acao, filtro })
    } else {
      resultado.push({ nome: str, modulo: str, acao: "*" })
    }
  }

  return resultado
}

export const temPermissao = (
  permissoes: PermissaoUsuario[],
  consulta: ConsultaPermissao | string
): boolean => {
  const nomes = new Set(permissoes.map((p) => p.nome))
  if (nomes.has("*")) return true

  if (typeof consulta === "string") {
    if (nomes.has(consulta)) return true
    const separador = consulta.includes(":") ? ":" : "_"
    const [mod, ac] = consulta.split(separador)
    if (ac) {
      return permissoes.some(
        (p) =>
          (p.modulo.toLowerCase() === mod.toLowerCase() || p.modulo === "*") &&
          (p.acao.toLowerCase() === ac.toLowerCase() || p.acao === "*")
      )
    }
    return false
  }

  if ("modulo" in consulta) {
    return permissoes.some((p) => {
      const moduloMatch =
        p.modulo.toLowerCase() === consulta.modulo.toLowerCase() || p.modulo === "*"
      const acaoMatch =
        p.acao.toLowerCase() === consulta.acao.toLowerCase() || p.acao === "*"
      const filtroMatch =
        consulta.filtros === undefined ||
        consulta.filtros.includes(p.filtro ?? "")
      return moduloMatch && acaoMatch && filtroMatch
    })
  }

  if ("any" in consulta) {
    return consulta.any.some((nome) => nomes.has(nome) || nomes.has("*"))
  }

  return (
    consulta.multiple.length > 0 &&
    consulta.multiple.every((nome) => nomes.has(nome) || nomes.has("*"))
  )
}

export const possuiPermissao = (
  permissoes: readonly string[],
  modulo: string,
  acao: "get" | "post" | "delete",
  escopos: readonly ("mine" | "group" | "all")[] = ["mine", "group", "all"]
): boolean => {
  const codigos = new Set(permissoes)
  return escopos.some((escopo) => codigos.has(`${modulo}_${acao}_${escopo}`))
}
